export const nextWeekdays = (count = 10) => {
  const days = [];
  const d = new Date();
  d.setDate(d.getDate() + 1);
  while (days.length < count) {
    if (d.getDay() !== 0 && d.getDay() !== 6) {
      days.push({
        iso: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`,
        label: d.toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" }),
      });
    }
    d.setDate(d.getDate() + 1);
  }
  return days;
};

export const formatSlot = (t) => {
  const [h, m] = t.split(":").map(Number);
  const suffix = h >= 12 ? "pm" : "am";
  const hour = h % 12 === 0 ? 12 : h % 12;
  return `${hour}:${String(m).padStart(2, "0")}${suffix}`;
};

const chipBase =
  "px-4 py-2.5 rounded-full text-xs font-semibold tracking-[0.15em] uppercase border transition-colors duration-300";

export const Chip = ({ active, disabled, onClick, children, testid }) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    data-testid={testid}
    className={`${chipBase} ${
      active
        ? "bg-[#DBB89C] border-[#DBB89C] text-[#FBF7F2]"
        : disabled
        ? "border-black/10 text-[#908B85]/40 line-through cursor-not-allowed"
        : "border-black/15 text-[#908B85] hover:border-[#DBB89C] hover:text-[#CFAEA5]"
    }`}
  >
    {children}
  </button>
);
